/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mobile_Admin_Impersonating_UserInputs */

const en_mobile_admin_impersonating_user = /** @type {(inputs: Mobile_Admin_Impersonating_UserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impersonating ${i?.name}`)
};

const es_mobile_admin_impersonating_user = /** @type {(inputs: Mobile_Admin_Impersonating_UserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impersonando a ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Impersonating {name}" |
*
* @param {Mobile_Admin_Impersonating_UserInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_impersonating_user = /** @type {((inputs: Mobile_Admin_Impersonating_UserInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_Impersonating_UserInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_impersonating_user(inputs)
	return en_mobile_admin_impersonating_user(inputs)
});